/* ─────────────────────────────────────────────
   cart.js — Lesly Curlz × Shopify AJAX Cart API
   Endpoints: /cart/add.js · /cart/change.js · /cart.js · /cart/clear.js
───────────────────────────────────────────── */

const LC_CART_FREE_SHIPPING = 3500; // 35€ en centimes

// ── Format monétaire ─────────────────────────
function lcFormatMoney(cents) {
  var fmt = (window.LC_SHOP && window.LC_SHOP.moneyFormat) || '€{{amount_with_comma_separator}}';
  var amount    = (cents / 100).toFixed(2);
  var amountInt = Math.round(cents / 100).toString();
  return fmt
    .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
    .replace('{{amount_no_decimals_with_comma_separator}}', amountInt.replace('.', ','))
    .replace('{{amount_no_decimals}}', amountInt)
    .replace('{{amount}}', amount);
}

// ── Fetch helpers ─────────────────────────────
async function lcCartGet() {
  const res = await fetch('/cart.js');
  return res.json();
}

async function lcCartAdd(variantId, quantity = 1, properties = {}) {
  const res = await fetch('/cart/add.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body:    JSON.stringify({ items: [{ id: variantId, quantity, properties }] })
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

async function lcCartChange(lineKey, quantity) {
  const res = await fetch('/cart/change.js', {
    method:  'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body:    JSON.stringify({ id: lineKey, quantity })
  });
  return res.json();
}

async function lcCartRemove(lineKey) {
  return lcCartChange(lineKey, 0);
}

// ── Badge navbar ──────────────────────────────
function refreshBadge(count) {
  const badge = document.getElementById('cartBadge');
  if (!badge) return;
  badge.textContent = count;
  badge.style.display = count > 0 ? 'flex' : 'none';
}

// ── Rendu du tiroir ────────────────────────────
async function renderCart() {
  const cart = await lcCartGet();
  const items = cart.items;
  const total = cart.total_price;
  const count = cart.item_count;

  const title = document.getElementById('cartTitle');
  if (title) title.textContent = count > 0 ? `🛍️ ${count} article${count > 1 ? 's' : ''}` : '🛍️ Mon panier';

  refreshBadge(count);

  const emptyEl  = document.getElementById('cartEmpty');
  const itemsEl  = document.getElementById('cartItems');
  const footerEl = document.getElementById('cartFooter');

  if (!emptyEl || !itemsEl) return;

  if (items.length === 0) {
    emptyEl.style.display  = 'flex';
    itemsEl.innerHTML      = '';
    if (footerEl) footerEl.style.display = 'none';
    return;
  }

  emptyEl.style.display = 'none';
  if (footerEl) footerEl.style.display = 'block';

  itemsEl.innerHTML = items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <img src="${item.image}" alt="${item.title}" loading="lazy">
      <div class="cart-item-info">
        <div class="cart-item-name">${item.product_title}</div>
        ${item.variant_title && item.variant_title !== 'Default Title'
          ? `<div style="font-size:.72rem;color:#A78BFA;margin-bottom:.2rem">${item.variant_title}</div>`
          : ''}
        <div class="cart-item-price-line">${lcFormatMoney(item.line_price)}</div>
        <div class="cart-item-qty">
          <button onclick="lcUpdateQty('${item.key}', ${item.quantity - 1})" aria-label="Moins">−</button>
          <span>${item.quantity}</span>
          <button onclick="lcUpdateQty('${item.key}', ${item.quantity + 1})" aria-label="Plus">+</button>
        </div>
      </div>
      <button class="cart-item-remove" onclick="lcUpdateQty('${item.key}', 0)" title="Supprimer">✕</button>
    </div>
  `).join('');

  // Barre livraison gratuite
  const left = Math.max(0, LC_CART_FREE_SHIPPING - total);
  const pct  = Math.min(100, (total / LC_CART_FREE_SHIPPING) * 100);
  const bar  = document.getElementById('cartShippingBar');
  if (bar) {
    bar.innerHTML = left > 0
      ? `<div style="background:rgba(124,58,237,.07);border-radius:12px;padding:.75rem 1rem">
           <p style="font-size:.75rem;color:var(--violet);font-weight:600;margin-bottom:.4rem">
             🚚 Plus que <strong>${lcFormatMoney(left)}</strong> pour la livraison gratuite !
           </p>
           <div style="height:5px;background:rgba(124,58,237,.12);border-radius:10px;overflow:hidden">
             <div style="height:100%;width:${pct}%;background:linear-gradient(135deg,#7C3AED,#A855F7);border-radius:10px;transition:width .5s"></div>
           </div>
         </div>`
      : `<div style="background:rgba(34,197,94,.08);border-radius:12px;padding:.65rem 1rem;text-align:center">
           <p style="font-size:.78rem;color:#16A34A;font-weight:700">✅ Livraison gratuite débloquée !</p>
         </div>`;
  }

  // Total
  const totalEl = document.getElementById('cartTotalAmount');
  if (totalEl) totalEl.textContent = lcFormatMoney(total);

  const totalLabel = document.getElementById('cartTotalLabel');
  if (totalLabel) totalLabel.textContent = `Total (${count} article${count > 1 ? 's' : ''})`;
}

// ── Mettre à jour la quantité ─────────────────
async function lcUpdateQty(lineKey, newQty) {
  try {
    await lcCartChange(lineKey, newQty);
    await renderCart();
  } catch (e) {
    lcToast('Erreur lors de la mise à jour 😕');
  }
}

// ── Ouvrir / fermer le tiroir ──────────────────
function openCart() {
  const drawer  = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');
  if (!drawer) return;
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  if (overlay) overlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  renderCart();
}

function closeCart() {
  const drawer  = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartOverlay');
  if (!drawer) return;
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  if (overlay) overlay.classList.remove('open');
  document.body.style.overflow = '';
}

// ── Ajouter au panier (appelé depuis product-hero) ──
async function addToCart(variantId, quantity, sourceEl) {
  if (!variantId) { lcToast('Variante introuvable 😕'); return; }
  const btn = document.getElementById('btnAddToCart');
  const originalText = btn ? btn.textContent.trim() : '';
  if (btn) { btn.disabled = true; btn.textContent = '⏳ Ajout…'; }

  try {
    await lcCartAdd(variantId, quantity);

    if (sourceEl) {
      flyToCart(sourceEl, async () => {
        const cart = await lcCartGet();
        refreshBadge(cart.item_count);
        lcToast('✅ Ajouté au panier !');
      });
    } else {
      const cart = await lcCartGet();
      refreshBadge(cart.item_count);
      lcToast('✅ Ajouté au panier !');
    }
  } catch (e) {
    lcToast('Erreur lors de l\'ajout 😕');
  } finally {
    if (btn) {
      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = originalText;
      }, 1200);
    }
  }
}

// ── Toast universel ────────────────────────────
function lcToast(msg) {
  let t = document.getElementById('toast');
  if (!t) { t = document.createElement('div'); t.id = 'toast'; t.className = 'toast'; document.body.appendChild(t); }
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(t._tid);
  t._tid = setTimeout(() => t.classList.remove('show'), 3500);
}

// Alias pour compatibilité avec l'ancien cart.js
const _cartToast = lcToast;

// ── Animation : produit → panier ───────────────
function flyToCart(sourceEl, callback) {
  const cartBtn = document.getElementById('cartBtn');
  if (!cartBtn || !sourceEl) { if (callback) callback(); return; }

  const src  = sourceEl.getBoundingClientRect();
  const dest = cartBtn.getBoundingClientRect();

  const bubble = document.createElement('div');
  bubble.style.cssText = `
    position:fixed;left:${src.left + src.width/2 - 30}px;top:${src.top + src.height/2 - 30}px;
    width:60px;height:60px;z-index:9999;pointer-events:none;
    background:white url('{{ 'creme.png' | asset_url }}') center/contain no-repeat;
    border-radius:50%;box-shadow:0 4px 20px rgba(124,58,237,.35);transition:none;
  `;
  document.body.appendChild(bubble);
  bubble.getBoundingClientRect(); // force reflow

  const endX = dest.left + dest.width/2 - 5;
  const endY = dest.top  + dest.height/2 - 5;
  bubble.style.transition = 'left .6s cubic-bezier(.4,.1,.2,1),top .6s cubic-bezier(.55,.05,.45,1),width .6s ease,height .6s ease,opacity .6s ease';
  bubble.style.left = endX + 'px'; bubble.style.top = endY + 'px';
  bubble.style.width = '10px'; bubble.style.height = '10px'; bubble.style.opacity = '0';

  bubble.addEventListener('transitionend', () => {
    bubble.remove();
    cartBtn.style.transition = 'transform .12s ease';
    cartBtn.style.transform  = 'scale(1.45)';
    setTimeout(() => { cartBtn.style.transform = ''; }, 220);
    if (callback) callback();
  }, { once: true });
}

// ── Init : badge au chargement ─────────────────
document.addEventListener('DOMContentLoaded', async () => {
  try {
    const cart = await lcCartGet();
    refreshBadge(cart.item_count);
  } catch (e) { /* silencieux */ }
});
